import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import { StepWrapperBox } from '../styledComponent/Boxes.style';

import { BaseStep, StepProps, TitleAndDescriptionProps, StepWizardProps } from '../common/BaseStep';
import { QuoteCard } from '../common/QuoteCard';

const Div = styled.div`
  margin-top: 8px;
`;

interface ReassuranceStepProps extends TitleAndDescriptionProps, StepProps, StepWizardProps {
  imageUrl: string;
  quote: string;
  quoteName?: string;
  imageBackgroundSize?: string;
  imageHeight?: string;
}

export const ReassuranceStep = (props: ReassuranceStepProps) => {
  const { imageUrl, quote, isActive, quoteName, imageBackgroundSize, imageHeight } = props;

  useEffect(() => {
    if (isActive) return window.scrollTo(0, 0);
  }, [isActive]);

  return (
    <>
      {isActive ? (
        <BaseStep {...props}>
          <StepWrapperBox>
            <Div>
              <QuoteCard imageUrl={imageUrl} quote={quote} quoteName={quoteName} imageBackgroundSize={imageBackgroundSize} imageHeight={imageHeight} />
            </Div>
          </StepWrapperBox>
        </BaseStep>
      ) : (
        ''
      )}
    </>
  );
};
